<div class="loading">
  <mat-spinner color="primary"></mat-spinner>
</div>
